/**
 * A constant string value representing an unknown item.
 *
 * This variable is typically used as a placeholder or default value
 * to identify cases where an item is not recognized or is unavailable.
 */
export const UNKNOWN_ITEM = 'Unknown item';
